import exportFromJSON from "../../../utils/csvSafe";
import { NavigateFunction } from "react-router-dom";
import { setErrorMsg } from "../../../redux/reducers/settingsSlice";
import { store } from "./../../../redux/store";
import {
  getRelatedPartiesStatusUpdate,
  getRelatedParties,
  getRelatedPartiesDetails,
} from "./API";

export interface filters {
  page?: number;
  size?: number;
  searchText?: string;
  loadAllDocuments: boolean;
  status?: string;
}

export interface RelatedParties {
  customerName?: string;
  name?: string;
  nationalId?: string;
  position?: string;
  status?: "PENDING" | "APPROVED" | "REJECTED";
  relationshipType?: string;
  financialDataId?: number;
  updatedAt?: string;
  createdAt?: string;
}

export interface RelatedPartiesList {
  details: RelatedParties[];
  totalCount: number;
}

export const callRequest = async (
  setData: React.Dispatch<React.SetStateAction<RelatedPartiesList>>,
  filters: filters
) => {
  setData(null);
  await getRelatedParties(filters, (_, data) => {
    setData({
      details: data?.details,
      totalCount: data?.totalCount,
    });
  });
};

export const showCusmtomerDetails = (t, item: RelatedParties) => {
  getRelatedPartiesDetails(t, item, (success, errorMsg) => {
    if (success) {
      message("Updated Successfully", true);
    } else {
      message("Something went wrong : " + errorMsg, false);
    }
  });
};

export const formateDate = (item) => {
  // return item ? new Date(item).toLocaleString() : "-";

  if (!item) return "-";
  const date = new Date(item);
  const formattedDate = date.toLocaleDateString("en-GB"); // e.g., 14/05/2025
  const formattedTime = date.toLocaleTimeString("en-US"); // e.g., 12:00:46 PM
  return (
    <strong>
      {formattedDate} <br /> {formattedTime}
    </strong>
  );
};

export const getRelatedPartiesUpdate = (data, refreshData: () => void) => {
  store.dispatch(
    setErrorMsg({
      icon: null,
      cancelBtnTitle: "Cancel",
      acceptBtnTitle: "OK",
      modalContentClass: "small",
      acceptBtnAction: async () => {
        getRelatedPartiesStatusUpdate(data, (success, errorMsg) => {
          if (success) {
            message("Updated Successfully", true);
            refreshData();
          } else {
            message("Something went wrong : " + errorMsg, false);
          }
        });
      },
      title: "Are you sure you want to",
      message: (
        <h2
          className={data.status == "APPROVED" ? "text-success" : "text-danger"}
        >
          {data.status}
        </h2>
      ),
    })
  );
};

const message = (data, reload) => {
  store.dispatch(
    setErrorMsg({
      icon: null,
      closeBtn: false,
      acceptBtnTitle: "OK",
      modalContentClass: "small",
      acceptBtnAction: () => {
        if (reload) window.location.reload();
      },
      title: "Status",
      message: data,
    })
  );
};

const getPosition = (count) => {
  if (count == 1) return "1st";
  if (count == 2) return "2nd";
  if (count == 3) return "3rd";
  if (count > 3) return count + 1 + "th";
  return count + "th";
};

export const showDetailsTable = (t, data, reload) => {
  store.dispatch(
    setErrorMsg({
      icon: null,
      title: "Customer's related parties",
      message: (
        <div
          className="scroller-area"
          style={{ maxHeight: "60vh", padding: 20 }}
        >
          <div className="row">
            <table className="table table-bordered table-striped">
              <thead>
                <tr>
                  <th className="px-2" scope="col">
                    {t("inputs.related_parties.relatedTo")}
                  </th>

                  <th className="px-2" scope="col">
                    {t("inputs.related_parties.relateiveName")}
                  </th>
                  <th className="px-2" scope="col">
                    {t("inputs.related_parties.nationalId")}
                  </th>
                  <th className="px-2" scope="col">
                    {t("inputs.related_parties.position")}
                  </th>

                  <th className="px-2" scope="col">
                    {t("inputs.related_parties.relationshipType")}
                  </th>
                  <th className="px-2" scope="col">
                    {t("inputs.related_parties.status")}
                  </th>
                  {/* <th className="px-2" scope="col">
                    {t("inputs.related_parties.createdAt")}
                  </th>
                  <th className="px-2" scope="col">
                    {t("inputs.related_parties.updatedAt")}
                  </th> */}
                </tr>
              </thead>
              <tbody>
                {Array.isArray(data) && data.length > 0 ? (
                  data.map((item, idx) => (
                    <tr key={idx}>
                      <td>{getPosition(idx + 1)}</td>
                      <td>{item.name}</td>
                      <td>{item.nationalId}</td>
                      <td>{item.position}</td>

                      <td>{item.relationshipType}</td>
                      <td>{item.status}</td>
                      {/* <td>{formateDate(item.createdAt)}</td>
                      <td>{formateDate(item.updatedAt)}</td> */}
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan={8} className="text-center">
                      No related parties found.
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      ),
    })
  );
};

// Printing pagination items
export const paginationElemnts = (
  dataArray: RelatedParties[],
  currentPage: number,
  length: number,
  setFilters: (value: React.SetStateAction<filters>) => void
): JSX.Element[] => {
  let pages: JSX.Element[] = [];
  let totalPage = Math.ceil(length / 10);

  const first = (
    <li key={1} className={"page-item" + (1 === currentPage ? " active" : "")}>
      <button
        className="btn btn-link"
        onClick={(e) => setFilters((res) => ({ ...res, page: 1 }))}
      >
        1
      </button>
    </li>
  );
  const last = (
    <li
      key={totalPage}
      className={"page-item" + (totalPage === currentPage ? " active" : "")}
    >
      <button
        className="btn btn-link"
        onClick={(e) => setFilters((res) => ({ ...res, page: totalPage }))}
      >
        {totalPage}
      </button>
    </li>
  );

  if (currentPage - 1 > 1) pages.push(first);
  for (let i = currentPage - 1; i <= currentPage + 1; i++) {
    if (i > 0 && i <= totalPage) {
      const element = (
        <li
          key={i.toString()}
          className={"page-item" + (i === currentPage ? " active" : "")}
        >
          <button
            className="btn btn-link"
            onClick={(e) => setFilters((res) => ({ ...res, page: i }))}
          >
            {i}
          </button>
        </li>
      );
      pages.push(element);
    }
    if (i === currentPage && dataArray?.length < 10) break;
  }
  if (totalPage - currentPage > 1) pages.push(last);

  return pages;
};

// Open details popup
export const showDetails = (
  t,
  Relatedparties: RelatedParties,
  navigate: NavigateFunction
) => {
  store.dispatch(
    setErrorMsg({
      icon: null,
      title: t("More Details"),
      message: (
        <div className="scroller-area" style={{ maxHeight: 550, padding: 20 }}>
          <div className="row">
            {printElements(t, Relatedparties).map((item) => item)}
          </div>
        </div>
      ),
    })
  );
};

const printElements = (t, dataArray: any): JSX.Element[] => {
  const array: JSX.Element[] = [];
  Object.keys(dataArray).forEach((key) => {
    array.push(
      <div className="col-12 col-md-6" key={key}>
        <div className="bordered-box">
          <strong>{t("inputs.payouts." + key).toString()}</strong>
          <span className="ms-2">
            {dataArray[key] === "" ||
            dataArray[key] === false ||
            dataArray[key] === undefined
              ? "-"
              : dataArray[key].toString()}
          </span>
        </div>
      </div>
    );
  });
  return array;
};

export const exportData = async (
  filters: filters,
  t: (key: string) => string
) => {
  await getRelatedParties(
    { ...filters, loadAllDocuments: true },
    (success, data) => {
      if (success && data && data?.details && data?.details?.length) {
        const fields = {
          createdAt: t("inputs.related_parties.createdAt"),
          customerName: t("inputs.related_parties.customerName"),
          name: t("inputs.related_parties.relateiveName"),
          financialDataId: t("inputs.related_parties.financialDataId"),
          nationalId: t("inputs.related_parties.nationalId"),
          position: t("inputs.related_parties.position"), // fixed typo here
          status: t("inputs.related_parties.status"),
          updatedAt: t("inputs.related_parties.updatedAt"),
          relationshipType: t("inputs.related_parties.relationshipType"),
        };
        const newData = [];
        data?.details?.forEach((item: RelatedParties) => {
          // use forEach instead of map
          newData.push({
            createdAt: item.createdAt ?? "",
            customerName: item.customerName ?? "",
            name: item.name ?? "",
            financialDataId: item.financialDataId ?? "",
            nationalId: item.nationalId ?? "",
            position: item.position ?? "",
            status: item.status ?? "",
            updatedAt: item.updatedAt ?? "",
            relationshipType: item.relationshipType ?? "",
          });
        });

        const fileName = "Related Parties";
        const exportType = exportFromJSON.types.csv;
        exportFromJSON({
          data: newData,
          fileName,
          exportType,
          fields,
          withBOM: true,
        });
      } else {
        // Optionally handle error or notify user
        // message("Export failed or no data to export.", false);
      }
    }
  );
};
